"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateOverwolfGameBodyTrackingProviderEnum = exports.CreateOverwolfGameBodyToJSON = exports.CreateOverwolfGameBodyFromJSONTyped = exports.CreateOverwolfGameBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function CreateOverwolfGameBodyFromJSON(json) {
    return CreateOverwolfGameBodyFromJSONTyped(json, false);
}
exports.CreateOverwolfGameBodyFromJSON = CreateOverwolfGameBodyFromJSON;
function CreateOverwolfGameBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'gameId': json['gameId'],
        'name': json['name'],
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : json['description'],
        'events': json['events'],
        'isEventSupported': json['isEventSupported'],
        'isEventSupportReady': json['isEventSupportReady'],
        'timeTrackedGame': !(0, runtime_1.exists)(json, 'timeTrackedGame') ? undefined : json['timeTrackedGame'],
        'slug': !(0, runtime_1.exists)(json, 'slug') ? undefined : json['slug'],
        'trackingProvider': !(0, runtime_1.exists)(json, 'trackingProvider') ? undefined : json['trackingProvider'],
        'steamAppId': !(0, runtime_1.exists)(json, 'steamAppId') ? undefined : json['steamAppId'],
        'seo': !(0, runtime_1.exists)(json, 'seo') ? undefined : (0, _1.CreateOverwolfGameBodySeoFromJSON)(json['seo']),
        'steamData': !(0, runtime_1.exists)(json, 'steamData') ? undefined : (0, _1.CreateOverwolfGameBodySteamDataFromJSON)(json['steamData']),
    };
}
exports.CreateOverwolfGameBodyFromJSONTyped = CreateOverwolfGameBodyFromJSONTyped;
function CreateOverwolfGameBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'gameId': value.gameId,
        'name': value.name,
        'description': value.description,
        'events': value.events,
        'isEventSupported': value.isEventSupported,
        'isEventSupportReady': value.isEventSupportReady,
        'timeTrackedGame': value.timeTrackedGame,
        'slug': value.slug,
        'trackingProvider': value.trackingProvider,
        'steamAppId': value.steamAppId,
        'seo': (0, _1.CreateOverwolfGameBodySeoToJSON)(value.seo),
        'steamData': (0, _1.CreateOverwolfGameBodySteamDataToJSON)(value.steamData),
    };
}
exports.CreateOverwolfGameBodyToJSON = CreateOverwolfGameBodyToJSON;
/**
* @export
* @enum {string}
*/
var CreateOverwolfGameBodyTrackingProviderEnum;
(function (CreateOverwolfGameBodyTrackingProviderEnum) {
    CreateOverwolfGameBodyTrackingProviderEnum["Overwolf"] = "overwolf";
    CreateOverwolfGameBodyTrackingProviderEnum["Blitz"] = "blitz";
    CreateOverwolfGameBodyTrackingProviderEnum["Steam"] = "steam";
    CreateOverwolfGameBodyTrackingProviderEnum["TimeOnly"] = "time-only";
})(CreateOverwolfGameBodyTrackingProviderEnum = exports.CreateOverwolfGameBodyTrackingProviderEnum || (exports.CreateOverwolfGameBodyTrackingProviderEnum = {}));
